import React from "react";
import "./footer.scss";
import logo from "../../media/logo_scg 2.png";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo">
          <img className="gambar-logo" src={logo} alt="logo-Parkspring" />
        </div>
        <div className="container-deskripsi">
          <div className="alamat">
            <h1>Marketing Gallery</h1>
            <h2>Summarecon Crown Gading</h2>
            <h3>Setia Asih, Tarumajaya, Bekasi Regency, West Java 17215</h3>
            <h4>Contact us : +6287713153298 (Billy)</h4>
          </div>
          <div className="privasi"></div>
        </div>
      </div>
      <div className="container-bawah">© Summarecon Crown Gading</div>
    </div>
  );
};

export default footer;
